// eslint-disable-next-line import/prefer-default-export

import { isNumber } from './numeric';

export const COLORS = {
  primary: '#F47721',
  secondary: '#E1CB31',
  primaryGrey: '#4A4A4A',
  accent: '#E1CB31',
  error: '#E33F3E',
  success: '#4caf50',
  warning: '#dfc720',
  priceMapGreen: '#82c564',
  seedHoldback: '#CA6218',

  // Progress Bar Colors
  progressBarRed: '#E33F3E',
  progressBarOrange: '#FFA843',
  progressBarDeepOrange: '#F47721',
  progressBarGreen: '#72A75A',
  backgroundGrey: '#EEEEEE',

  // Cashflow Progress Colors
  outflow: '#ffa843',
  inflow: '#427AF1',

  plotlyLine: '#00873C',
  plotlyMountainGradientLeft: '#00873C00',
  plotlyMountainGradientRight: '#00873C33',

  plotlyBollingerBorder: '#8A2BE2',
  plotlyBollingerLine: '#00FA9A',

  plotlyBollingerMountainFill: '#80808033',

  plotlyMACDLine: '#1E90FF',
  plotlyMACDLineFill: '#1E90FF33',
  plotlyMACDSignal: '#FF4500',
  plotlyMACDSignalFill: '#FF450033',
  plotlyMACDHistogram: '#99999933',

  plotlyCOTFunds: '#8E24AA',
  plotlyCOTFundsFill: '#8E24AA33',
  plotlyCOTCommercials: '#42A5F5',
  plotlyCOTCommercialsFill: '#42A5F533',

  plotlyRSIUndersold: 'rgba(255, 0, 0, 0.2)', // Polygonal logic for RSI doesn't accept HEX
  plotlyRSIOversold: 'rgba(0, 0, 255, 0.2)',

  plotlyGreyTooltip: '#4A4A4A',
  plotlySpike: '#5B636A',

  plotlyRelativeValueMainColor: '#1B60F4',
  plotlyRelativeValueRelatedColor: '#A81B1B',
  plotlyRelativeValueSpreadColor: '#ffbb75',

  grainfoxAIButton: '#12A8C4',
  grainfoxAIBackground: '#E9F6FD',
  grainfoxAILinearTop: '#D3F6FF',
  grainfoxAIButtonBorder: '#009EDC80',
};
export const GREEN_YELLOW_BORDER = 0.66;
export const YELLOW_RED_BORDER = 0.33;

export function getPriceMapColorFromTemperature(temperature) {
  if (!isNumber(temperature)) {
    return null;
  }
  if (temperature < 0 || temperature > 1) {
    return null;
  }
  let color = 'green';
  if (temperature < GREEN_YELLOW_BORDER) {
    if (temperature < YELLOW_RED_BORDER) {
      color = 'red';
    } else {
      color = 'yellow';
    }
  }
  return color;
}

// TODO: This should actually be based on the palette.js values,
// with intermediate colours generated programmatically.
export default [
  [{ background: '#E1CB31', text: '#4A4A4A' }, { background: '#EBE085', text: '#4A4A4A' }, { background: '#F5EFC2', text: '#4A4A4A' }, { background: '#F9F5D6', text: '#4A4A4A' }, { background: '#FCFAEA', text: '#4A4A4A' }],
  [{ background: '#4A4A4A', text: '#FFFFFF' }, { background: '#929292', text: '#4A4A4A' }, { background: '#C8C8C8', text: '#4A4A4A' }, { background: '#E9E9E9', text: '#4A4A4A' }, { background: '#F6F6F6', text: '#4A4A4A' }],
  [{ background: '#E33F3E', text: '#FFFFFF' }, { background: '#EB7877', text: '#FFFFFF' }, { background: '#F4B2B1', text: '#4A4A4A' }, { background: '#FAD8D8', text: '#4A4A4A' }, { background: '#FCEBEB', text: '#4A4A4A' }],
  [{ background: '#F47721', text: '#4A4A4A' }, { background: '#F79F63', text: '#4A4A4A' }, { background: '#FBC8A6', text: '#4A4A4A' }, { background: '#FDE4D2', text: '#4A4A4A' }, { background: '#FEF1E8', text: '#4A4A4A' }],
  [{ background: '#2E1438', text: '#FFFFFF' }, { background: '#817288', text: '#FFFFFF' }, { background: '#BFB8C3', text: '#4A4A4A' }, { background: '#E6E2E7', text: '#4A4A4A' }, { background: '#F4F3F5', text: '#4A4A4A' }],
  [{ background: '#848C8C', text: '#FFFFFF' }, { background: '#B6BABA', text: '#4A4A4A' }, { background: '#DADCDC', text: '#4A4A4A' }, { background: '#E6E8E8', text: '#4A4A4A' }, { background: '#F0F1F1', text: '#4A4A4A' }],
];
